/* Responsibility: Updates state of checkbox with count and if enabled */
import preconditions from '../lib/preconditions.js';
import checkBoxFilterUtils from './modules/checkboxFilterUtils.js';

const checkPreconditions = preconditions('checkBoxState', {
    root: 'element',
    eventHub: 'eventHub',
    dataKey: 'string',
    urlKey: 'string',
    resultViewCriteria: 'object',
});

export default function checkboxState(params) {
    checkPreconditions(params);
    const cbfn = checkBoxFilterUtils(params);

    const updateState = function (data) {
        const facets = cbfn.flattenFacetsLists(data[params.dataKey]);
        cbfn.eachCheckbox((box) => {
            cbfn.setState(box, cbfn.entryCountFromName(facets, box.value));
        });
        cbfn.updateResultViewCriteria(params.resultViewCriteria, params.urlKey, cbfn.isUnchecked);
    };

    params.eventHub.subscribe('changed-results', updateState);
}
